import { Outlet, ScrollRestoration, useSearchParams } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import { useReactiveVar } from '@apollo/client'

import { ROLE_FACILITATOR, ROLE_MANAGER } from './constants'

import 'react-toastify/dist/ReactToastify.css'
import './App.css'

import { apolloAuthData } from './services/apollo'
import { Header, Footer, FacilFab } from './components'

function App() {
  const auth = useReactiveVar(apolloAuthData)
  const isManager = auth.user?.capabilities?.includes(ROLE_MANAGER)
  let [searchParams] = useSearchParams()
  const isEditOn = isManager && !!searchParams.get('edit')

  return (
    <div className="text-sm [&_p:not(:last-of-type)]:mb-5 [&_ul:not(.nostyle)]:mb-4 [&_ul:not(.nostyle)]:list-disc [&_ul:not(.nostyle)]:pl-8">
      <ToastContainer
        hideProgressBar
        newestOnTop
        position={toast.POSITION.BOTTOM_RIGHT}
      />
      <Header />
      {auth.user?.capabilities?.includes(ROLE_FACILITATOR) && <FacilFab />}
      <Outlet />
      {!isEditOn && <ScrollRestoration />}
      <Footer />
    </div>
  )
}

export default App
